import * as actions from "./actionsTypes";

const defaultState = {
  data: [],
  loading: false,
};

export default (state = [], action) => {
  switch (action.type) {
    case actions.GET_USER_TRANSACTIONS_REQUEST:
      // let addExample = [action.data, ...state.data];
      return action.data;
    default:
      return state;
  }
};
